import { Entity } from '@contact/upgrade';

import { MailCommentType } from '../mail-comment/models/mail-comment';
import { EpticaSelector } from './eptica-selector';

export enum IEpticaExtractAttachmentAction {
  ADDED = 'ADDED',
  REMOVED = 'REMOVED',
  ADDED_BY_DRAFT_LOADING = 'ADDED_BY_DRAFT_LOADING',
  NONE = 'NONE',
}

export enum IEpticaExtractAttachmentFrom {
  ASK_FOR_HELP,
  TRANSFER,
}

export interface IEpticaExctractAttachment {
  title: string;
  source: string;
  file: any;
  filename: string;
  sizeInFrame?: string;
  action?: IEpticaExtractAttachmentAction;
  fromType?: IEpticaExtractAttachmentFrom;
}

export interface IEpticaExtractHistoryData {
  source: Entity[];
  target: Entity[];
}

export interface IEpticaExtractActor {
  from: string;
  to: string;
}

export interface IEpticaExtractDescription {
  title: string;
  shortTitle: string;
  actor: IEpticaExtractActor;
}

export interface IEpticaExtractInfo {
  description: IEpticaExtractDescription;
  date: Date;
  attachment: IEpticaExctractAttachment[];
  canal: string;
  sender: string;
  recipient: string;
  ccRecipient: string;
  bccRecipient: string;
  subject: string;
  agent?: string;
  comment?: string;
  content: string;
  contentId: string;
  contentSrc: string;
  contentHtml: string;
  skill: IEpticaExtractHistoryData;
}

export interface IEpticaExctractEvent extends IEpticaExtractInfo {
  requestId: number;
  selector: EpticaSelector;
  bounceType?: MailCommentType;
  response?: IEpticaExtractInfo;
  isPlainTextFormat: boolean;
}

export interface IEpticaMailContent {
  evt: IEpticaExctractEvent;
  disabled: boolean;
  open: boolean;
  conversational: boolean;
  allAttachment;
  index: number;
  isHtmlFormat: boolean;
}
